import Phone from 'ui/Phone/Phone';
export default Phone;
